import { combineReducers } from 'redux';

import filterOptions from './filter-options';
import filter from './filter';
import posts from './posts';
import page from './page';

const reducer = combineReducers({ filter, filterOptions, posts, page });
export default reducer;



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/resource-grid/reducers/index.js